import axios from 'axios'
import configServer from '../configs/service'
import {getLocalData, setLocalData, removeLocalData} from "./StorageServices"
import {getLocalIP} from '../helpers/getLocalIP'

const _stores = {
    subscribes: []
}

const _addSubscriber = (subscriber) => {
    if (subscriber && typeof subscriber === 'function' && !_stores.subscribes.includes(subscriber)) {
        _stores.subscribes.push(subscriber)
    }
}

const _removeSubscriber = (subscriber) => {
    _stores.subscribes.filter((sub) => sub !== subscriber)
}

const _callAllSubscribes = (res, error) => {
    _stores.subscribes.forEach(sub => {
        sub(res, error)
    })
}

const getToken = () => {
    return getLocalData('accessToken')
}

const setToken = (token) => {
    setLocalData('accessToken', token)

    _callAllSubscribes()
}

const removeToken = () => {
    removeLocalData('accessToken')

    _callAllSubscribes()
}

const makeAuthRequest = (auth = true) => {

    let options = {
        baseURL: configServer.url
    }
    const instance = axios.create(options)

    return async (args) => {
        try {
            const _additionOptions = {
                headers: {}
            }
            console.log('1. Get lanIp')

            let lanIP = sessionStorage.getItem('lanIp')

            console.log('2. Get lanIp = ', {lanIP})

            if (!lanIP) {
                console.log('3. Get lanIp')
                getLocalIP(4).then(ip => {
                    console.log('3.1. Get lanIp')
                    sessionStorage.setItem('lanIp', ip)

                    return ip
                })
                console.log('4. Get lanIp', {lanIP})
            }
            // Ko có thì chịu :)
            _additionOptions['headers']['X-LOCAL-IP'] = lanIP

            if (auth) {
                _additionOptions['headers']['Authorization'] = `Bearer ${getToken()}`
            }

            const res = await instance({..._additionOptions, ...args})

            _callAllSubscribes(res, null)

            return res
        } catch (e) {
            _callAllSubscribes(null, e)

            throw e
        }
    }
}

const isAuthenticated = () => {
    const token = getLocalData('accessToken')

    return !!token
}

export {makeAuthRequest, _addSubscriber, _removeSubscriber, isAuthenticated, removeToken, setToken, getToken}
